import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { UserService } from '../../services';
import { FIRST_NAME_EDIT_VALIDATORS, LAST_NAME_EDIT_VALIDATORS } from '../../validators';
import * as moment from 'moment-timezone';

@Component({
  selector: 'app-right-obs-panel',
  templateUrl: './right-obs-panel.component.html',
  styleUrls: ['./right-obs-panel.component.scss']
})
export class RightObsPanelComponent implements OnInit {

  @Input() observator;
  @Output() closePanelEvent = new EventEmitter<void>();
  @Output() saveObserverEvent = new EventEmitter<{ formData: any, observatorId: number }>();
  @Output() deleteObserverEvent = new EventEmitter<void>();

  public obsForm: FormGroup;
  public linkAvatarObs: string;

  constructor(
      public fb: FormBuilder,
      public userService: UserService
  ) {}

  ngOnInit() {
    this.obsForm = this.fb.group({
      firstName: ['', FIRST_NAME_EDIT_VALIDATORS],
      lastName: ['', LAST_NAME_EDIT_VALIDATORS],
      phonePrefix: [null],
      phone: ['', [
        Validators.minLength(4),
        Validators.maxLength(15),
        Validators.pattern(/^[0-9]*$/)
      ]],
      email: ['', [
        Validators.required
      ]],
      typeCare: [null],
      avatar: [null],
      timezone: [moment.tz.guess()]
    });

    this.loadObservator();
  }

  loadObservator() {
    const observator = this.observator;

    this.linkAvatarObs = this.observator.avatar;

    // UWAGA: `avatar` musi zostać w formularzu jako ścieżka oddana przez API.
    // Zapis idzie PUT-em, a Symfony submituje go z clearMissing = true: `null` albo
    // pominięty klucz kasuje zdjęcie w bazie. Odesłanie ścieżki to jedyny wariant
    // „nie ruszaj zdjęcia" — transformer edycji przepuszcza stringa nietkniętego.
    // Z tego samego powodu formularz musi lecieć KOMPLETNY, nie różnicowo.
    this.obsForm.patchValue({
      firstName: observator.firstName,
      lastName: observator.lastName,
      phonePrefix: observator.phonePrefix,
      phone: observator.phone,
      email: observator.email,
      typeCare: observator.typeCare,
      avatar: observator.avatar,
      timezone: observator.timezone
    });
  }

  closePanel() {
    this.closePanelEvent.emit();
  }

  saveObserver() {
    if (this.obsForm.valid) {
      this.saveObserverEvent.emit({ formData: this.obsForm.value, observatorId: this.observator.id });

    }
  }

  changeAvatarObs(changedAvatar) {
    this.obsForm.get('avatar').setValue(changedAvatar);
    this.linkAvatarObs = changedAvatar;
  }

  deleteObserver() {
    this.deleteObserverEvent.emit(this.observator);
  }

}
